<template>
    <div v-show="visible" class="modal fade show" :id="id" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="staticBackdropLabel" aria-modal="true" style="display: block">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title fs-3" id="staticBackdropLabel">{{ title }}</h5>
                </div>
                <div class="modal-body">
                    <p class="fs-4">{{ text }}</p>
                    <slot name="motivo" />
                </div>
                <div class="modal-footer">
                    <button type="button" v-if="usarConfirmar" class="btn btn-primary" data-bs-dismiss="modal"
                        @click="ok"> {{captionConfirm ? captionConfirm : "Confirmar"}}</button>
                    <button type="button" v-if="usarNegar" class="btn btn-secondary" data-bs-dismiss="modal"
                        @click="cancelar">{{captionCancelar ? captionCancelar : "Não"}}</button>
                </div>
            </div>
        </div>

    </div>
    <div v-show="visible" class="modal-backdrop fade show" id="backdrop"></div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ModalAgape',
    emits: ['modalResult'],
    props: ['visible', 'title', 'id', "text", "usarConfirmar", "usarNegar","captionConfirm","captionCancelar"],
    setup(props, { emit }) {


        function ok() {
            emit("modalResult", "ok", props.id);
        }
        function cancelar() {
            emit("modalResult", "cancel", props.id);
        }
        return {
            ok,
            cancelar
        };
    }
});
</script>

<style scoped>
.modal-content {
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}

@media only screen and (min-width: 1014px) {
    .modal-dialog {
        max-width: 50% !important;
    }
}
</style>